/**
 * 4Talks - Video controls
 *
 * @author Matt Haynes
 * @package Joi Polloi
 */

const splashVideo = () => {
    const videoEl = Array.from(document.querySelectorAll('.splashVideo'));
    const videoControls = document.getElementById('splashVideoControls');
    if (!videoEl || !videoControls) return;

    videoControls.addEventListener('click', () => {
        if (videoEl[0].paused) {
            videoEl.forEach(video => {
                video.play();
            });
            videoControls.setAttribute('aria-label', 'Pause 4 Talks video ad');
            videoControls.innerHTML = '<span class="vh">Pause 4 Talks video ad</span>';
            videoControls.classList.add('playing');
        } else {
            videoEl.forEach(video => {
                video.pause();
            });
            videoControls.setAttribute('aria-label', 'Play 4 Talks video ad');
            videoControls.innerHTML = '<span class="vh">Play 4 Talks video ad</span>';
            videoControls.classList.remove('playing');
        }
    });

    const homeSplash = document.getElementById('homeSplash');

    if (homeSplash) {
        const content = document.querySelector('.home__content').getBoundingClientRect();
        const checkpoint = content.top;
        let opacity = 1;

        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll <= checkpoint) {
                opacity = 1 - ((currentScroll / checkpoint) * 1.5);
            } else {
                opacity = 0;
            }
            document.getElementById('homeSplash').style.opacity = opacity;
        });
    }
};

export default splashVideo;
